import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class BaseComponent extends React.Component {

    defaultTimeFormat = 'HH:mm';
    defaultDateFormat = 'D. M. YYYY';

    scrollToTop() {
        window.scrollTo(0,0);
    }

    spinner(show) {
        if (!show) return;

        return (
            <span className='ml-2 mr-2'>
                <FontAwesomeIcon icon={['far', 'spinner']} spin/>
            </span>
        );
    }

    parseDateString(date) {
        return (date ? new Date(date) : date);
    }

}

export default BaseComponent;
